var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronCircleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.34375C14.5 6.03125 13.25 3.90625 11.25 2.71875C9.21875 1.5625 6.75 1.5625 4.75 2.71875C2.71875 3.90625 1.5 6.03125 1.5 8.34375C1.5 10.6875 2.71875 12.8125 4.75 14C6.75 15.1562 9.21875 15.1562 11.25 14C13.25 12.8125 14.5 10.6875 14.5 8.34375ZM0 8.34375C0 5.5 1.5 2.875 4 1.4375C6.46875 0 9.5 0 12 1.4375C14.4688 2.875 16 5.5 16 8.34375C16 11.2188 14.4688 13.8438 12 15.2812C9.5 16.7188 6.46875 16.7188 4 15.2812C1.5 13.8438 0 11.2188 0 8.34375ZM7.53125 12.125C7.21875 12.4375 6.75 12.4375 6.46875 12.125C6.15625 11.8438 6.15625 11.375 6.46875 11.0625L9.1875 8.34375L6.46875 5.625C6.15625 5.34375 6.15625 4.875 6.46875 4.5625C6.75 4.28125 7.21875 4.28125 7.53125 4.5625L10.7812 7.84375C11.0625 8.125 11.0625 8.59375 10.7812 8.875L7.53125 12.125Z",
    fill: "#22333B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircleLeft);
export default __webpack_public_path__ + "static/media/chevron-circle-left.e137f61b76c77d7ce23a86d77bde4a28.svg";
export { ForwardRef as ReactComponent };